import { EmptyControl } from '@hvlng/framework-bff/core';
import { HvlQueryModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { HvlDateConverter } from '@hvlng/framework-bff/util';

@JsonObject('KovanHrTimeConstrainedBaseQueryModel')
export class TimeConstrainedBaseQueryModel extends HvlQueryModel {
    @EmptyControl()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate?: Date = null;

    @EmptyControl()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate?: Date = null;

    @EmptyControl()
    @JsonProperty('reverseBeginDateEndDateCheck', Boolean, true)
    reverseBeginDateEndDateCheck?: boolean = null;
}
